import { render, staticRenderFns } from "./message-table.vue?vue&type=template&id=13cfc28f&scoped=true"
import script from "./message-table.vue?vue&type=script&lang=js"
export * from "./message-table.vue?vue&type=script&lang=js"
import style0 from "./message-table.vue?vue&type=style&index=0&id=13cfc28f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cfc28f",
  null
  
)

export default component.exports